var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessionExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5684 0H67.3727C67.3727 1.34291 66.2839 2.43164 64.941 2.43164C63.5981 2.43164 62.5094 1.34291 62.5094 0H51.7453C51.7453 1.34291 50.6566 2.43164 49.3137 2.43164C47.9708 2.43164 46.882 1.34291 46.882 0H36.118C36.118 1.34291 35.0292 2.43164 33.6863 2.43164C32.3434 2.43164 31.2547 1.34291 31.2547 0H20.4906C20.4906 1.34291 19.4019 2.43164 18.059 2.43164C16.7161 2.43164 15.6273 1.34291 15.6273 0H2.43164C1.08873 0 0 1.08873 0 2.43164V13.0227C0 14.3656 1.08873 15.4544 2.43164 15.4544H80.5684C81.9113 15.4544 83 14.3656 83 13.0227V2.43164C83 1.08873 81.9113 0 80.5684 0Z",
    fill: "#2F86A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6274 0V6.33848C15.6274 7.68139 16.7162 8.77012 18.0591 8.77012C19.402 8.77012 20.4907 7.68139 20.4907 6.33848V0H15.6274Z",
    fill: "#FFE705"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2546 0V6.33848C31.2546 7.68139 32.3434 8.77012 33.6863 8.77012C35.0292 8.77012 36.1179 7.68139 36.1179 6.33848V0H31.2546Z",
    fill: "#FFE705"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8821 0V6.33848C46.8821 7.68139 47.9708 8.77012 49.3137 8.77012C50.6566 8.77012 51.7454 7.68139 51.7454 6.33848V0H46.8821Z",
    fill: "#FFCB00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5093 0V6.33848C62.5093 7.68139 63.598 8.77012 64.9409 8.77012C66.2838 8.77012 67.3726 7.68139 67.3726 6.33848V0H62.5093Z",
    fill: "#FFCB00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5684 83H2.43164C1.08873 83 0 81.9112 0 80.5683V13.0227H83V80.5683C83 81.9112 81.9113 83 80.5684 83Z",
    fill: "#F4F1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83 80.5683V13.0227H41.5V83H80.5684C81.9113 83 83 81.9112 83 80.5683Z",
    fill: "#ECEAE7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.15 72.5817H12.8499C11.5069 72.5817 10.4182 71.493 10.4182 70.15V13.0227H72.5818V70.15C72.5816 71.4931 71.4931 72.5817 70.15 72.5817Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5817 70.15V13.0227H41.5V72.5817H70.1501C71.4932 72.5817 72.5817 71.4931 72.5817 70.15Z",
    fill: "#F4F1F1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6047 62.1636H28.3952C25.4714 62.1636 22.747 60.5907 21.2853 58.0587C19.8235 55.5265 19.8235 52.3808 21.2853 49.8488L34.3902 27.1506C35.8521 24.6186 38.5765 23.0457 41.5001 23.0457C44.4238 23.0457 47.1482 24.6186 48.6101 27.1506L61.7149 49.8488C63.1766 52.3806 63.1766 55.5264 61.7149 58.0585C60.253 60.5907 57.5285 62.1636 54.6047 62.1636Z",
    fill: "#FFCB00"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.715 58.0585C63.1767 55.5265 63.1767 52.3808 61.715 49.8488L48.6102 27.1506C47.1481 24.6186 44.4239 23.0457 41.5002 23.0457V62.1636H54.605C57.5286 62.1636 60.2531 60.5907 61.715 58.0585Z",
    fill: "#FF9D21"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 27.9089C40.3081 27.9089 39.1977 28.5501 38.6018 29.5822L25.4969 52.2805C24.9011 53.3125 24.9011 54.5947 25.4969 55.6272C26.0928 56.6592 27.2032 57.3003 28.3951 57.3003H54.6047C55.7966 57.3003 56.9072 56.6592 57.5031 55.627C58.0988 54.5949 58.0988 53.3126 57.5031 52.2805L44.3983 29.5822C43.8024 28.5501 42.6918 27.9089 41.5 27.9089Z",
    fill: "#FFE705"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5031 55.627C58.0989 54.5949 58.0989 53.3126 57.5031 52.2805L44.3984 29.5822C43.8024 28.5501 42.6918 27.9089 41.5 27.9089V57.3003H54.6048C55.7966 57.3003 56.9072 56.6592 57.5031 55.627Z",
    fill: "#FFCB00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 45.2339C40.1571 45.2339 39.0684 44.1452 39.0684 42.8022V38.2444C39.0684 36.9015 40.1571 35.8127 41.5 35.8127C42.8429 35.8127 43.9316 36.9015 43.9316 38.2444V42.8022C43.9316 44.1452 42.8429 45.2339 41.5 45.2339Z",
    fill: "#5C504A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 54.3499C40.1571 54.3499 39.0684 53.2612 39.0684 51.9183V51.2671C39.0684 49.9242 40.1571 48.8354 41.5 48.8354C42.8429 48.8354 43.9316 49.9242 43.9316 51.2671V51.9183C43.9316 53.2612 42.8429 54.3499 41.5 54.3499Z",
    fill: "#5C504A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9316 42.8022V38.2444C43.9316 36.9015 42.8429 35.8127 41.5 35.8127V45.2339C42.8429 45.2339 43.9316 44.1452 43.9316 42.8022Z",
    fill: "#262927"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9316 51.9183V51.2671C43.9316 49.9242 42.8429 48.8354 41.5 48.8354V54.3499C42.8429 54.3499 43.9316 53.2612 43.9316 51.9183Z",
    fill: "#262927"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionExpired);
export default __webpack_public_path__ + "static/media/session_expired.7bdd60d5dec70507c419884b28efcacf.svg";
export { ForwardRef as ReactComponent };